module.exports = __webpack_public_path__ + "img/blueEye.db96c56a.svg";